import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { uploadObject } from '../../rest/data';
import { copyRestObject, Language } from '../../rest/models';
import { Valid, RequestStatusDisplay } from '../CommonComponents';
import { Button, Input } from "../RequestRespectingInputs";
import { useState } from 'react';
import { RequestStatus } from '../../api_request/api_request';
import { getModelArr } from '../../rest/slice';

export function LanguageEditForm(props: Props)
{
    const appDispatch = useAppDispatch();

    function copyLang(l?: Language)
    {
        const ret = copyRestObject(l ?? new Language(), Language);
        return ret;
    }

    //The language as it is in the editor form.
    const [l, setL] = useState(copyLang(props.lang));

    //Keeps track of what's happening with the request.
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);
    
    const loginState = useAppSelector((state) => state.login);

    const isDuplicate = (getModelArr(useAppSelector, Language) ?? [])
        .filter(l2 => l.name === l2.name) //Objects with the same properties as the current form.
        .some(l2 => l.key !== l2.key); //Unless it's the same object that we're editing. It can equal itself.

    //The next two things are visible only if the current user is a privileged user.
    //Public objects appear for all users, not just the ones that created them.
    const forAllHeader = loginState.currentUser.is_staff ? <th>Public (admin function)</th> : <></>
    const forAllField = loginState.currentUser.is_staff
    ? <td>
        <Input
            type='checkbox'
            checked={l.public}
            onChange={(e) => {l.public = e.currentTarget.checked; setL({...l});}} />
      </td>
    : <></>

    const nameInput = 
        <Input
            type='text'
            value={l.name}
            maxLength={100}
            onChange={(e) => {l.name = e.currentTarget.value; setL({...l});}} />;

    const gtransCodeInput = 
        <Input
            type='text'
            value={l.gtrans_code}
            maxLength={100}
            onChange={(e) => {l.gtrans_code = e.currentTarget.value; setL({...l});}} />;
    
    const submitButton = 
        <Button
            onClick={async function()
            {
                if (isDuplicate)
                {
                    window.alert('This language has the same text and language as another one.');
                    return;
                }

                const status = await uploadObject(l, Language, appDispatch, setRequest);
                if (status.success)
                {
                    setL(copyLang());
                    props.onDone();
                }
            }}>Submit</Button>;

    const form = 
        <div>
            <table border={1}>
                <tbody>
                    <tr>
                        <td><b>Name</b></td>
                        <td>
                            {nameInput}
                            <Valid bValid={l.name.trim() || !l.id} children='Languages must have a name.'/>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Google Translate code</b></td>
                        <td>
                            {gtransCodeInput}
                        </td>
                    </tr>
                    <tr>
                        {forAllHeader}
                        {forAllField}
                    </tr>
                </tbody>
            </table>
            
            {submitButton}
            {l.id ? <Button onClick={(e) => props.onDone()}>Hide</Button> : <></>}
        </div>;

    const createOrEdit = l.id ? 'Edit' : 'Create';
    return (
        <div className={`ernots_${createOrEdit}ModelForm`}>
            {form}
            <RequestStatusDisplay request={request}/>
        </div>);
}

interface Props
{
    lang?: Language;
    onDone: () => void;
}